/* eslint-disable react/jsx-filename-extension */
/* eslint-disable max-len */

import React from "react";
import Discuss from "parts/Discuss";
import Button from "elements/Button";
import BenefitsSection from "components/BenefitsSection";

export default function HostedPrivateCloud() {
  return (
    <>
      {/* FEATURES SECTION */}
      <section className="py-20 bg-premium-light">
        <div className="container mx-auto px-6">
          <h2 className="text-3xl lg:text-4xl text-surface-900 font-extrabold text-center mb-6 tracking-tight">
            Private Cloud Capabilities
          </h2>
          <p className="text-center text-surface-300 text-lg mb-12">
            A dedicated cloud environment engineered for uptime, flexibility, and next-level security.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="glass-card-static p-6 rounded-2xl">
              <h3 className="text-xl font-semibold text-surface-900 mb-2">
                Dedicated Resources
              </h3>
              <p className="text-surface-300 leading-relaxed">
                Guaranteed performance with isolated compute, storage, and networking.
              </p>
            </div>

            <div className="glass-card-static p-6 rounded-2xl">
              <h3 className="text-xl font-semibold text-surface-900 mb-2">
                High Availability
              </h3>
              <p className="text-surface-300 leading-relaxed">
                Redundant infrastructure designed for uninterrupted operations.
              </p>
            </div>

            <div className="glass-card-static p-6 rounded-2xl">
              <h3 className="text-xl font-semibold text-surface-900 mb-2">
                Enterprise Security
              </h3>
              <p className="text-surface-300 leading-relaxed">
                Advanced controls including encryption, segmentation, MFA, and compliance support.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* BENEFITS SECTION (Reusable) */}
      <BenefitsSection
        title="Why Hosted Private Cloud?"
        subtitle="Private cloud offers the control and security enterprises need without sacrificing flexibility."
        benefits={[
          {
            id: "predictable-costs",
            title: "Predictable Monthly Costs",
            text: "One flat-rate monthly plan that includes infrastructure, management, and support.",
            delay: 0,
          },
          {
            id: "compliance",
            title: "Enhanced Compliance",
            text: "Ideal for regulated industries that require strict data governance and control.",
            delay: 120,
          },
          {
            id: "control-security",
            title: "Greater Control & Security",
            text: "Full visibility and control over your cloud environment, backed by enterprise security.",
            delay: 240,
          },
        ]}
        gainsTitle="What You’ll Gain"
        gains={[
          { id: "uptime", text: "Superior uptime" },
          { id: "compliance-gain", text: "Improved compliance" },
          { id: "governance", text: "Better data governance" },
          { id: "security-posture", text: "Stronger security posture" },
        ]}
      />

      {/* CTA SECTION */}
      <section className="py-20 bg-premium-accent">
        <div className="container mx-auto px-6 flex flex-col lg:flex-row items-center justify-between gap-6">
          <div>
            <h2 className="text-2xl lg:text-3xl text-surface-900 font-extrabold tracking-tight">
              Looking for a secure cloud alternative?
            </h2>
            <p className="text-surface-300 mt-2 text-lg">
              Let us design a private cloud environment built for your business.
            </p>
          </div>

          <Button
            href="/contact"
            type="link"
            className="btn-premium text-base px-8 py-4"
          >
            Book a Consultation
          </Button>
        </div>
      </section>

      <Discuss />
    </>
  );
}
